/**
 * Checks if the dateUntil for the product is set
 * If not, redirect to Step 1 of that flow.
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct<ProductActivity | ProductAccommodation>(to);
    const { firstStepRoute } = useFlow(to);

    if (!product.value.dateUntil) {
        return navigateTo(firstStepRoute.value);
    }
});
